import { toast } from "react-toastify";
import firebase from "firebase/compat/app";
toast.configure();

var user_api_url = process.env.REACT_APP_USER_API_URL;
var job_api_url = process.env.REACT_APP_JOB_API_URL;
var profile_api_url = process.env.REACT_APP_PROFILE_API_URL;
var peer_api_url = process.env.REACT_APP_PEER_API_URL;
var candidate_web_url = process.env.REACT_APP_CANDIDATE_WEB_URL;
var elastic_search_api_url = process.env.REACT_APP_ELASTIC_SEARCH_API_URL;
var google_api_key = process.env.REACT_APP_GOOGLE_API_KEY;
var google_analytics_id = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
var discourse_url = process.env.REACT_APP_DISCOURSE_URL;

var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const ENV = {
  login_url: user_api_url + "candidate/login",
  signup_url: user_api_url + "candidate/signup",
  logout_url: user_api_url + "candidate/logout",
  basicInfoUrl: profile_api_url + "candidate/profile/basicinfo",
  experience_url: profile_api_url + "candidate/profile/experience",
  education_url: profile_api_url + "candidate/profile/education",
  review_url: profile_api_url + "candidate/profile/review",
  preference_url: profile_api_url + "candidate/profile/jobpreferences",
  alljobs_url:elastic_search_api_url,
  highlights_url: profile_api_url + "candidate/profile/highlights",
  upload_document_url: profile_api_url + "candidate/files/upload",
  document_url: profile_api_url + "candidate/files",
  skills_url: job_api_url + "skills/categories?",
  updateskill_url: profile_api_url + "candidate/profile/skills",
  softskill_url: profile_api_url + "candidate/profile/softskills",
  certification_url: profile_api_url + "candidate/profile/certifications",
  language_url: profile_api_url + "candidate/profile/languages",
  skillverification_url:
    profile_api_url + "candidate/profile/skills/verification",
  metaDataEnumsUrl: profile_api_url + "candidate/metadata/constants",
  search_skills_url: job_api_url + "skills/languages?",
  languages_url: job_api_url + "skills?",
  softskills_url: job_api_url + "skills?",
  applyjob_url: job_api_url + "candidate/job/apply",
  peerrating_url: peer_api_url + "peerrating/candidate/request",
  peerrating_list_url: peer_api_url + "peerrating/candidate/request",
  AvgPeerrating_url: peer_api_url + "peerrating/candidate/rating",
  peerratingskills_url: peer_api_url + "peerrating/reviewer/rating/skills/",
  peerratingsoftskills_url:
    peer_api_url + "peerrating/reviewer/rating/softskills/",
  peerratinglanguagesskills_url:
    peer_api_url + "peerrating/reviewer/rating/languages/",
  peerratingdetails_url: peer_api_url + "peerrating/reviewer/rating/details/",
  reviewerrating_url: peer_api_url + "peerrating/reviewer/rating/",
  appliedjob_url: job_api_url + "candidate/job/appliedjobs",

  appliedjobdetails_url: job_api_url + "candidate/job/appliedjobs",

  approveExperience_url:
    profile_api_url + "candidate/files/resume/parse/exp/approve/",
  approveEducation_url:
    profile_api_url + "candidate/files/resume/parse/edu/approve/",
  get_job_url: job_api_url + "candidate/job/",
  candidate_web_url: candidate_web_url,
  firebaseConfig: firebaseConfig,
  google_api_key: google_api_key,
  google_analytics_id: google_analytics_id,
  elasticSearch_url: elastic_search_api_url + "candidate/search/jobs",
  jobMetaDataEnumsUrl: job_api_url + "job/metadata/constants",

  notification_url: user_api_url + "candidate/notifications",
  sso_login_url: user_api_url + "candidate/forum/login",
  // discourse_session_url: discourse_url + "session/sso",
  discourse_session_url: discourse_url,
};

export function validateErrorResponse(errorResponse, type) {
  if (errorResponse.response === undefined) {
  } else {
    if (errorResponse.response.status === 400) {
      if (errorResponse.response.data.failure_code === "BASICINFO_EXISTS") {
      } else if (
        errorResponse.response.data.failure_code === "INVALID_PROFILE"
      ) {
        window.localStorage.setItem("profile", "notcompleted");
        window.localStorage.setItem("basicInfo", "notcompleted");
      }
    } else if (errorResponse.response.status === 401) {
      if (errorResponse.response.data.failure_code === "INVALID_USER") {
        window.location.href = "/";
      } else if (
        errorResponse.response.data.failure_code === "INVALID_USER_SESSION"
      ) {
        sessionExpired();
      } else if (
        errorResponse.response.data.failure_code === "INVALID_BEARER_TOKEN" ||
        errorResponse.response.data.failure_code === "MISSING_BEARER_TOKEN"
      ) {
        sessionExpired();
      }
    } else if (errorResponse.response.status === 404) {
      if (type === "login") {
        window.localStorage.setItem("account", "NewUser");
        window.localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
      } else {
      }
    }
  }
}

export function isNullOrEmpty(value) {
  if (
    value == null ||
    value === "" ||
    value === undefined ||
    value === "undefined"
  ) {
    return true;
  } else {
    return false;
  }
}

export function showSalary(salary) {
  return salary.toLocaleString();
}

const sessionExpired = () => {
  const p = window.localStorage.getItem("page");
  if (isNullOrEmpty(p)) {
    if (window.localStorage.getItem("user") !== null) {
      closeSession();
    } else {
      window.localStorage.clear();
      sessionStorage.clear();
    }
  } else {
    closeSession();
  }
};

const closeSession = () => {
  toast.error("Session Expired. Login again");
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.href = "/";
    })
    .catch(function () {
      window.location.href = "/";
    });
};
